import  {Component} from "react";
import ReactDOM from 'react-dom';
import {Button, Layout, message, Modal, Tree} from "antd";
import AxiosUtil from "../../utils/AxiosUtil";
import NavHeader from "../../components/NavHeader";
import SiderMenuMain from "../../components/SiderMenuMain";
import NavBreadcrumb from "../../components/NavBreadcrumb";
import NavFooter from "../../components/NavFooter";
import React from "react";
import {SettingOutlined} from "@ant-design/icons";
import EditableTable from "../../components/EditableTable";
import DataUtil from "../../utils/DataUtil";
import moment from "moment";

const {Content} = Layout;

interface IProps {
}

export default class Role extends Component<IProps> {

    state = {
        showPermission: false,
        settingRoleId: 0,
        settingRoleName: "",
        settingRoleFunctions: [],
        mainData: [],
        paramData: []
    }

    componentDidMount() {
        //组件加载完成后触发
        AxiosUtil.AxiosRequest('/api/param/sl', {parent_id: 1}, this.loadParam);
        this.reload();
    }
    reload = ()=>{
        AxiosUtil.AxiosRequest('/api/role/list', {}, this.loadMainData);
    }

    render() {

        const crumb = [
            {name: '系统管理'},
            {name: '角色权限'},
        ];

        return (
            <Layout>
                <NavHeader />
                <Content className={"main-body"}>
                    <Layout>
                        <SiderMenuMain/>
                        <Content className={'main-content'}>
                            <NavBreadcrumb itemList={crumb}/>
                            <div id="mainTable"></div>

                            <Modal title={<div><SettingOutlined /> 设置权限：<span className="blue">{this.state.settingRoleName}</span></div>}
                                   visible={this.state.showPermission}
                                   onOk={this.savePermission}
                                   onCancel={this.hidePermission}
                                   forceRender={true}
                                   centered>
                                <div id="functionTree">

                                </div>
                            </Modal>
                        </Content>
                    </Layout>
                </Content>
                <NavFooter/>
            </Layout>


        );
    }
    hidePermission = () =>{
        this.setState({showPermission: false})
    }
    savePermission = () => {
        if (!this.state.settingRoleFunctions) {
            message.error({content: '权限设置没有任何改变！', className: 'message_error'})
            return;
        }
        const callback = (suc: boolean, dat: any) => {
            if (suc) {
                console.log(suc, dat)
                message.success({content: '权限设置成功！', className: 'message_success'});
                //this.reload();
            }
        }

        const powers = [];
        for (let i = 0; i < this.state.settingRoleFunctions.length; i++) {
            powers.push({function_id: this.state.settingRoleFunctions[i], r: '1', w: '1'});
        }
        const post = {
            rid: this.state.settingRoleId,
            powers: powers
        }
        console.log(post);
        AxiosUtil.AxiosRequest('/api/function/power', post, callback);
        this.setState({showPermission: false})
    }
    saveRecord = (record:any) => {
        console.log('save:', record);
        const callback = (suc: boolean, dat: any) => {
            if (suc) {
                console.log(suc,dat)
                message.success({content:'保存成功！',className:'message_success'});
                this.reload();
            }
        }
        AxiosUtil.AxiosRequest('/api/role/grid', {list: [record]}, callback);
    }
    deleteRecord = (record_key:string) =>{
        const callback = (suc: boolean, dat: any) => {
            if (suc) {
                console.log(suc,dat)
                message.success({content:'记录已删除成功！',className:'message_success'});
            }
        }
        AxiosUtil.AxiosRequest('/api/role/grid', {list: [{role_id:record_key,isDelete:1}]}, callback);
    }
    sortRecord = (records: any[]) =>{
        const callback = (suc: boolean, dat: any) => {
            if (suc) {
                console.log(suc,dat)
                message.success({content:'排序保存成功！',className:'message_success'});
            }
        }
        AxiosUtil.AxiosRequest('/api/role/grid', {list: records}, callback);
    }
    loadMainData = (suc: boolean, dat: any) => {
        if (suc) {
            this.setState({mainData: dat.list});
            this.renderEditableTable();
        }
    }
    loadParam = (suc: boolean, dat: any) => {
        if (suc) {
            this.setState({paramData: dat.list});
            this.renderEditableTable();
        }
    }
    renderEditableTable = () =>{
        if (this.state.mainData.length >0 &&
            this.state.paramData.length>0
        ) {
            const columns = [
                {
                    title: 'ID',
                    key: 'role_id',
                    dataIndex: 'role_id',
                    width: 40,
                    align: 'center' as 'center',
                },
                {
                    title: '角色',
                    key: 'role_name',
                    dataIndex: 'role_name',
                    width: 200,
                    editable: true,
                    editor: {type: 'text', required: true}
                },
                {
                    title: '类型',
                    key: 'role_type_name',
                    dataIndex: 'role_type_name',
                    width: 200,
                    editor: {
                        type: 'select',
                        idField: 'role_type',
                        valueField: 'param_id',
                        textField: 'param_name',
                        data: this.state.paramData,
                        required: true
                    }
                },
                {
                    title: '备注',
                    key: 'remark',
                    dataIndex: 'remark',
                    width: 200,
                    editable: true,
                    editor: {type: 'text'}
                },
                {
                    title: '权限',
                    key: 'id1',
                    dataIndex: 'role_id',
                    width: 88,
                    align: 'center' as 'center',
                    render: (text: any,record:any) =>
                        <Button type="link" onClick={() => this.loadFunctionData(text,record.role_name)}>
                            <SettingOutlined/>
                        </Button>

                },
            ];
            const r = moment().format("X");
            ReactDOM.render(
                <EditableTable
                    key={r}
                    columns={columns}
                    datas={this.state.mainData}
                    record_key="role_id"
                    saveCallback={this.saveRecord}
                    deleteCallback={this.deleteRecord}
                    reloadCallback={this.reload}
                    sortCallback={this.sortRecord}
                />
                , document.getElementById("mainTable")
            )
        }
    }
    onFinishAiForm = (values: any) => {
        console.log('Received values of form: ', values);

    }
    loadFunctionData =(id: string, name: string)=>{
        const onCheck=(checkedKeys:any, e:any)=>{
            this.setState({settingRoleFunctions:[...checkedKeys,...e.halfCheckedKeys]});
        }
        const callback = (suc: boolean, dat: any) => {
            if (suc) {
                let myData = DataUtil.treeDataClean(dat,'function_name','function_id');

                let checkedKeys:any[] = [],checkedNotes:any[] = [];
                const getChecked = (data: any) => {
                    for (let i = 0; i < data.length; i++) {
                        if (data[i].children) {
                            if (data[i].r === 1)
                                checkedKeys.push(data[i].function_id)
                            getChecked(data[i].children)
                        } else {
                            if (data[i].r === 1) {
                                checkedKeys.push(data[i].function_id)
                                checkedNotes.push(data[i].function_id)
                            }
                        }
                    }
                }
                getChecked(myData);

                this.setState({
                    showPermission: true,
                    settingRoleId: id,
                    settingRoleName: name,
                    settingRoleFunctions: null
                })

                ReactDOM.render(
                    <Tree key={moment().format("X")}
                          defaultExpandAll={true}
                          checkable
                          onCheck={onCheck}
                          treeData={myData}
                          defaultCheckedKeys={checkedNotes}
                    />
                    , document.getElementById("functionTree")
                )
            }
        }
        AxiosUtil.AxiosRequest('/api/function/list', {rid:id}, callback);
    }
}


